import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class SubscriptionGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    const decide = (): boolean | UrlTree =>
      this.userService.hasActivePlan()
        ? true
        : this.router.createUrlTree(['/dashboard', 'plan']);

    if (this.userService.currentUser()) {
      return of(decide());
    }
    return this.userService.loadUserInfo().pipe(map(() => decide()));
  }
}
